import { Form } from "./Form";
import { SELECTORS } from "./Constants";
import { List } from "./List";

const forms = document.querySelectorAll<HTMLFormElement>(SELECTORS.form);
if (forms.length) {
    forms.forEach((form) => {
        new Form(form).init().then();
    });
}

const list = document.querySelector<HTMLDivElement>(SELECTORS.accountList);
if (list) {
    new List(list).init();
}
